import type { ITheme } from 'threads5/themes/theme';

/** Rich-text unordered list styles shared across section wrappers. */
export const unorderedListStyles = (theme: ITheme) => {
  return {
    margin: '16px 0 0 0',
    [theme.breakpoints.up('sm')]: {
      margin: '24px 0 0 0',
    },
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),

    // marker styles
    'li::marker': {
      color: theme.palette['graphic/interactive/neutral/resting/high'],
    },

    // normal bullet list styles
    'li:not(:has(svg))': {
      marginLeft: '20px',
    },

    // icon bullet list styles
    'li:has(svg)': {
      listStyleType: 'none',
    },
    'p:has(.icon-wrapper)': {
      position: 'relative',
      paddingLeft: '32px', // width of the icon + 8px gap
      '.icon-wrapper': {
        position: 'absolute',
        left: '0',
        top: '-1px',
        svg: {
          color: theme.palette['graphic/interactive/neutral/resting/high'],
          zoom: 1.3,
        },
      },
    },

    // ⚠️⚠️⚠️ legacy decorative text styles ⚠️⚠️⚠️
    'p:has(.decorative-text)': {
      '& svg': {
        marginTop: '-4px',
        zoom: 1, // we use zoom because it works for all icons
      },
      [theme.breakpoints.up('md')]: {
        marginBottom: '16px',
        '& svg': {
          marginTop: '-3px',
          zoom: 1.2,
        },
      },
    },
  };
};
